import { CheckboxFieldPlugin } from "../../customFields/plugins/CheckboxFieldPlugin";
import { CurrencyFieldPlugin } from "../../customFields/plugins/CurrencyFieldPlugin";
import { DateFieldPlugin } from "../../customFields/plugins/DateFieldPlugin";
import { MultiSelectFieldPlugin } from "../../customFields/plugins/MultiSelectFieldPlugin";
import { NumberFieldPlugin } from "../../customFields/plugins/NumberFieldPlugin";
import { SelectFieldPlugin } from "../../customFields/plugins/SelectFieldPlugin";
import { TextFieldPlugin } from "../../customFields/plugins/TextFieldPlugin";
import { SpectrumCheckboxFieldPluginDecorator } from "../plugins/checkbox/SpectrumCheckboxFieldPluginDecorator";
import { SpectrumCurrencyFieldPluginDecorator } from "../plugins/currency/SpectrumCurrencyFieldPluginDecorator";
import { SpectrumDateFieldPluginDecorator } from "../plugins/date/SpectrumDateFieldPluginDecorator";
import { SpectrumEmailFieldPluginDecorator } from "../plugins/email/SpectrumEmailFieldPluginDecorator";
import { SpectrumMultiSelectFieldPluginDecorator } from "../plugins/multiSelect/SpectrumMultiSelectFieldPluginDecorator";
import { SpectrumNumberFieldPluginDecorator } from "../plugins/number/SpectrumNumberFieldPluginDecorator";
import { SpectrumPhoneFieldPluginDecorator } from "../plugins/phone/SpectrumPhoneFieldPluginDecorator";
import { SpectrumSelectFieldPluginDecorator } from "../plugins/select/SpectrumSelectFieldPluginDecorator";
import { SpectrumTextFieldPluginDecorator } from "../plugins/text/SpectrumTextFieldPluginDecorator";
import { spectrumFieldPlugins } from "./spectrumFieldPluginRegistrar";

let isInitialized = false;
let initPromise: Promise<void> | null = null;

/**
 * Initializes the spectrum field plugin registrar.
 *
 * This function is used to initialize the spectrum field plugin registrar.
 */
export async function initSpectrumFieldPluginRegistrar(): Promise<void> {
  if (isInitialized) {
    if (initPromise) {
      await initPromise;
    }
    return;
  }

  // Register safe decorators synchronously so callers that don't await still have base functionality.
  spectrumFieldPlugins.push(
    new SpectrumCheckboxFieldPluginDecorator(CheckboxFieldPlugin),
    new SpectrumCurrencyFieldPluginDecorator(CurrencyFieldPlugin),
    new SpectrumDateFieldPluginDecorator(DateFieldPlugin),
    new SpectrumEmailFieldPluginDecorator(TextFieldPlugin),
    new SpectrumMultiSelectFieldPluginDecorator(MultiSelectFieldPlugin),
    new SpectrumNumberFieldPluginDecorator(NumberFieldPlugin),
    new SpectrumPhoneFieldPluginDecorator(TextFieldPlugin),
    new SpectrumSelectFieldPluginDecorator(SelectFieldPlugin),
    new SpectrumTextFieldPluginDecorator(TextFieldPlugin),
  );

  // Only register GraphQL-dependent decorators outside of Storybook builds.
  if (import.meta.env.STORYBOOK !== "true") {
    // eslint-disable-next-line lingui/no-unlocalized-strings
    initPromise = import("./initSpectrumFieldPluginRegistrarHeavy").then((importedModule) => {
      importedModule.registerHeavySpectrumFieldPlugins();
    });
    await initPromise;
  }

  isInitialized = true;
}
